import React, { useState } from "react";
import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

const RemoveUserConfirmationModal = ({
    show,
    close,
    orgName,
    userId,
    platformId,
    orgId,
    email,
    updateUserOrgStatus,
    refetchOrgStatus,
}) => {
    const [localLoading, setLocalLoading] = useState(false);

    const handleConfirm = async () => {
        setLocalLoading(true);
        await updateUserOrgStatus({
            userId,
            body: {
                platforms: {
                    [platformId]: {
                        organizations: {
                            [orgId]: {
                                membership_status: "Remove-Requested",
                                reason: "User initiated removal from portal",
                                changed_by: email.toLowerCase(),
                            },
                        },
                    },
                },
            },
            attribute: "membership_status",
        });
        // Optionally refetch org status here if you have a refetch function
        if (refetchOrgStatus) {
            await refetchOrgStatus();
        }
        setLocalLoading(false);
        close();
    };

    return (
        <Dialog open={show} onClose={close} /* ...rest props... */>
            <DialogTitle id="scroll-dialog-title" sx={{ background: "white" }}>
                CONFIRM ACTION
            </DialogTitle>
            <DialogContent
                sx={{
                    maxWidth: "600px",
                    minWidth: "320px",
                    color: "black",
                    letterSpacing: "0.00938em",
                    padding: "0px 24px",
                }}
            >
                <div style={{ marginBottom: "18px", wordBreak: "break-word" }}>
                    <p style={{ marginBottom: "0px" }}>
                        Are you sure you want to remove yourself from the&nbsp;
                        <b>{orgName} org?</b>
                    </p>
                </div>
                <div style={{ marginBottom: "30px" }}>
                    <div
                        style={{
                            listStyle: "none",
                            marginTop: "5px",
                            border: "1px solid lightgray",
                            borderRadius: "3px",
                            padding: "5px",
                            paddingLeft: "10px",
                            marginBottom: "5px",
                            backgroundColor: "whitesmoke",
                        }}
                    >
                        <strong>Note:&nbsp;</strong> This process may take somewhere between
                        45-60 minutes to process. Once removed, you will need to request
                        access again to rejoin the organization.
                    </div>
                </div>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "flex-end" }}>
                <Stack
                    direction="row"
                    spacing={5}
                    sx={{
                        padding: "0.2rem 0rem",
                        margin: "0 auto",
                        alignContent: "center",
                        justifyContent: "center",
                    }}
                >
                    <Button
                        title="Cancel"
                        sx={{
                            backgroundColor: "white",
                            letterSpacing: "0.5px",
                            border: "1px solid gray",
                            padding: "4px 16px",
                            borderRadius: "3px",
                            fontSize: "14px",
                            color: "black",
                            cursor: `${localLoading ? "not-allowed" : "pointer"}`,
                        }}
                        onClick={close}
                        disabled={localLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        title="Confirm Removal"
                        sx={{
                            backgroundColor: "green",
                            letterSpacing: "0.5px",
                            padding: "4px 16px",
                            borderRadius: "3px",
                            fontSize: "14px",
                            color: "white",
                            cursor: `${localLoading ? "not-allowed" : "pointer"}`,
                            "&:hover": {
                                backgroundColor: "#015e01",
                                color: "white",
                            },
                        }}
                        onClick={handleConfirm}
                        disabled={localLoading}
                    >
                        {localLoading ? (
                            <>
                                <CircularProgress size={14} sx={{ color: "white" }} />
                                <span style={{ marginLeft: "5px" }}>Removing...</span>
                            </>
                        ) : (
                            "Confirm"
                        )}
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default RemoveUserConfirmationModal;
